import { render } from "./menu.vue?vue&type=template&id=4bac8698&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=4bac8698&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=4bac8698&lang=scss"
script.render = render
script.__scopeId = "data-v-4bac8698"

export default script